import { isFuture } from 'date-fns/esm';
import { MaintenanceInfo, RawMaintenanceData } from '../maintenance-types';

export const createMaintenanceInfo = (
  rawInfo: RawMaintenanceData,
): MaintenanceInfo => {
  return {
    ...rawInfo,
    start: new Date(rawInfo.start),
    end: new Date(rawInfo.end),
    // for debugging
    // start: addHours(new Date(), 5),
    // end: addHours(new Date(), 10),
  };
};

export const shouldShowBanner = (info: MaintenanceInfo) => {
  // while in maintenance - the app will be blocked
  // so there's no point to toggle the banner on.
  return isFuture(info.start);
};

export const shouldBlockApp = (info: MaintenanceInfo) => {
  return info.isActive;
};
